import { render } from "./EntityList.vue?vue&type=template&id=2d9b8a4e&scoped=true"
import script from "./EntityList.vue?vue&type=script&lang=js"
export * from "./EntityList.vue?vue&type=script&lang=js"

import "./EntityList.vue?vue&type=style&index=0&id=2d9b8a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9b8a4e"]])

export default __exports__